import type { TransactionReturnType } from "../types"
import type { Address } from "viem"
import type { Config } from "wagmi"
import { parseAbi } from "viem"

import { simulatedTransaction } from "../simulated-transaction"

/* eslint-disable */

type UnwrapNativeProps = {
  account: Address
  chainId: number
  config: Config
  nativeAddress: Address
  amount: bigint
}

export const unwrapNative = async ({
  account,
  chainId,
  config,
  nativeAddress,
  amount,
}: UnwrapNativeProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: parseAbi(["function withdraw(uint256 wad)"]),
        account,
        address: nativeAddress,
        args: [amount],
        chainId,
        functionName: "withdraw",
      },
    })
    return result
  } catch (error: any) {
    console.error("wrapNative", error)
    return { success: false, error: error.message, code: error.code }
  }
}
